import {
  FileUploadOutlined,
  PaidOutlined,
  UploadFileOutlined,
} from "@mui/icons-material";
import { lazy, Suspense, useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import LoadingFallback from "../../../components/LoadingFallback";
import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { sidebarTypeToggle } from "../../../redux/actions/sidebarActions";

// Lazy load heavy components
const DropdownButton = lazy(
  () => import("../../../components/ui/buttons/DropdownButton")
);
const LoanBulkFileUploader = lazy(
  () => import("../shared/LoanBulkFileUploader")
);
// const LoanSizerUploader = lazy(() => import("../shared/LoanSizerUploader"));

const UploadToLoanDropdownButton = () => {
  const dispatch = useDispatch();
  const [showUpload, setShowUpload] = useState(false);

  const handleUploadClose = useCallback(() => {
    setShowUpload(false);
  }, []);

  const handleUploadClick = useCallback(() => {
    setShowUpload(true);
  }, []);

  const handleSizerUploadClick = useCallback(() => {
    dispatch(sidebarTypeToggle(loanDrilldownSidebarTypes.SIZER_UPLOAD));
  }, [dispatch]);

  const options = [
    {
      label: "Upload Loan Files",
      onClick: handleUploadClick,
      icon: <UploadFileOutlined className="thin" />,
    },
    {
      label: "Upload Loan Sizer",
      onClick: handleSizerUploadClick,
      icon: <PaidOutlined />,
    },
  ];

  return (
    <>
      <Suspense fallback={<LoadingFallback />}>
        <LoanBulkFileUploader show={showUpload} onClose={handleUploadClose} />

        <DropdownButton
          // size="small"
          // size="large"
          endIcon={
            <FileUploadOutlined
            // sx={{ fontSize: "16px !important" }}
            // className="thin"
            />
          }
          // variant="outlined"
          options={options}
        >
          Upload
          {/* Upload To Loan */}
        </DropdownButton>
      </Suspense>
    </>
  );
};

export default UploadToLoanDropdownButton;
